import { render, staticRenderFns } from "./GJgrowEventCreateTermExamAtBefore.vue?vue&type=template&id=2e286947&scoped=true&"
import script from "./GJgrowEventCreateTermExamAtBefore.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateTermExamAtBefore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e286947",
  null
  
)

export default component.exports